var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.model.entity)?_c('json-form',{attrs:{"schema":_vm.schema,"errors":_vm.errors,"labels":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }